module.exports = __webpack_public_path__ + "media/images/emblems/Russikon-blazon-52288b5575493f6614ee240de19bca82.svg";